<template>
  <div>
    <div class="d-flex align-center column-gap-2 text-text-secondary">
      <span>
        <span class="text--small text--bold">{{ $t('project.signing-checklist.SigningChecklistSummary.totalDocuments') }}</span>
        <v-chip size="small" class="ml-2">
          <span class="text--x-small">
            {{ totalDocuments }}
          </span>
        </v-chip>
      </span>
      <template v-if="allowEnvelopeGrouping && totalEnvelopes">
        <div class="mx-2" style="height: 22px">
          <v-divider :vertical="true" />
        </div>
        <span>
          <span class="text--small text--bold">
            <span v-t="{
                  path: 'project.signing-checklist.SigningChecklistSummary.totalEnvelopes',
                  plural: totalEnvelopes,
                }"
            />
          </span>
          <v-chip size="small" class="ml-2">
            <span class="text--x-small">
              {{ totalEnvelopes }}
            </span>
          </v-chip>
        </span>
      </template>
    </div>
    <p v-if="isSendingDocuments" class="mt-2 text--small">
      <span v-t="{
                  path: 'project.signing-checklist.SigningChecklistSummary.isSendingDocumentsIntro',
                  plural: totalDocuments,
                }"
            />
    </p>
    <app-alert-in-page v-if="totalDocumentsInError" :dismissible="false" variant="warning" class="my-4">
      <i18n-t :keypath="alertContent" tag="span" scope="global" :plural="totalDocumentsInError" class="text-text-secondary">
        <template #document>
          <b>
            {{ totalDocumentsInError }}
            <span v-t="{
                path: 'common.document',
                plural: totalDocumentsInError,
              }"
            />
          </b>
        </template>
      </i18n-t>
    </app-alert-in-page>
    <div class="signing-checklist-summary-lists">
      <template v-if="data && !isLoading">
        <template v-if="!isOrdered">
          <SigningChecklistSummaryList :groups="computedGroups[0]"/>
        </template>
        <template v-else>
          <v-timeline align="start" density="compact" truncate-line="start">
            <v-timeline-item
              v-for="(groups, index) in computedGroups"
              :key="'groups_' + index"
              dot-color="#D3E3FD"
              fill-dot
              size="small"
            >
              <SigningChecklistSummaryList :envelope-starting-index="getEnvelopeStartingIndex(index)"
                                           :groups="groups" />
              <template v-slot:icon>
                <p class="timeline-step ma-auto text--button-small">{{ index + 1 }}</p>
              </template>
            </v-timeline-item>
          </v-timeline>
        </template>
      </template>
      <template v-else>
        <v-skeleton-loader type="paragraph"/>
      </template>
    </div>
  </div>
</template>

<script>
import { DARK_BLUE_500 } from '@/common/utils/colors'
import SigningChecklistSummaryList from '@/project/signing-checklist/SigningChecklistSummaryList.vue'

export default {
  name: 'SigningChecklistSummary',
  components: { SigningChecklistSummaryList },
  props: {
    allowEnvelopeGrouping: {
      type: Boolean,
      default: false,
    },
    data: {
      type: [Object, null],
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isSendingDocuments: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      DARK_BLUE_500,
    }
  },
  computed: {
    alertContent () {
      return 'project.signing-checklist.SigningChecklistSummary.' + (this.isSendingDocuments ? 'errorSendDocuments' : 'errorStartSigning')
    },
    computedGroups () {
      return Object.values(this.data?.groups)
    },
    isOrdered () {
      return this.computedGroups.length > 1 || false
    },
    totalDocuments () {
      return this.data?.documentsCount || null
    },
    totalDocumentsInError () {
      let tot = 0
      this.data?.groups.forEach(groups => {
        if (groups.waitingCorrection) { tot += groups.waitingCorrection.length }
      })
      return tot
    },
    totalEnvelopes () {
      return this.data?.envelopesCount || null
    },
  },
  methods: {
    getEnvelopeStartingIndex (activeIndex) {
      let envelopeStartingIndex = 0

      for (let index = 0; index < activeIndex; index++) {
        if (this.computedGroups[index].ready?.length) envelopeStartingIndex++
        if (this.computedGroups[index].waitingValidation?.length) envelopeStartingIndex++
      }

      return envelopeStartingIndex
    },
  },
}
</script>

<style scoped lang="scss">
.signing-checklist-summary-lists {
  max-height: 35vh;
  margin-top: 24px;
  overflow-y: auto;
}
.v-timeline {
  padding-top: 0;
}
.timeline-step {
  color: v-bind(DARK_BLUE_500);
}
:deep(.v-timeline-item__body) {
  width: 100%;
}
</style>
